import { useState, useEffect } from 'react';
import { ContrastSensitivitySetup, ContrastSensitivityTest, ContrastSensitivityResults } from '..';
import ExamEyeSetup from '../exams/ExamEyeSetup';
import { useTestContext } from '../../../context/testContext';
import { usePostMessage } from '../../../context/messageContext';
import { StepBody, useTestStepSync } from '../testScreenKit';

const ContrastSensitivity = ({ setTitle, setActiveTab }) => {
  const { testData, updateTestData } = useTestContext();
  const [step, setStep] = useState('eyeSetup');
  const postMessage = usePostMessage();
  useTestStepSync(testData.testKey, step);

  useEffect(() => {
    switch (step) {
      case 'eyeSetup':
        setTitle('Contrast Sensitivity Test');
        break;
      case 'rightEyeSetup':
        setTitle('Contrast Sensitivity Test - Right Eye');
        break;
      case 'leftEyeSetup':
        setTitle('Contrast Sensitivity Test - Left Eye');
        if (testData.testRightEye) updateTestData({ testInProgress: true });
        break;
      case 'bothEyesSetup':
        setTitle('Contrast Sensitivity Test - Binocular');
        break;
      case 'rightEyeTest':
        setTitle('Contrast Sensitivity Test - Right Eye');
        break;
      case 'leftEyeTest':
        setTitle('Contrast Sensitivity Test - Left Eye');
        break;
      case 'bothEyesTest':
        setTitle('Contrast Sensitivity Test - Binocular');
        break;
      case 'results':
        setTitle('Contrast Sensitivity Test Results');
        break;
      default:
        break;
    }
  }, [setTitle, step, updateTestData, testData.testRightEye]);

  const updateStep = (selectedStep) => {
    if (selectedStep === 'results') postMessage({ type: 'endOfTest' });
    if (selectedStep.endsWith('Setup')) postMessage({ type: 'holding' });
    return setStep(selectedStep);
  };

  const renderSwitch = () => {
    switch (step) {
      case 'eyeSetup':
        return <ExamEyeSetup updateStep={updateStep} />;
      case 'bothEyesSetup':
      case 'rightEyeSetup':
      case 'leftEyeSetup':
        return <ContrastSensitivitySetup eyeTested={step.split('S')[0]} updateStep={updateStep} />;
      case 'rightEyeTest':
      case 'leftEyeTest':
      case 'bothEyesTest':
        return <ContrastSensitivityTest eyeTested={step.split('T')[0]} updateStep={updateStep} />;
      case 'results':
        return <ContrastSensitivityResults localResults={testData} setActiveTab={setActiveTab} updateStep={updateStep} />;
      default:
        return;
    }
  };

  return (
    <StepBody data-testid='contrast-sensitivity' data-step={step}>
      {renderSwitch()}
    </StepBody>
  );
};

export default ContrastSensitivity;
